import type { ValueTagType } from './primitives/ValueTag';

/** Safely coerce unknown values to finite numbers (0 for NaN/Infinity/null/undefined). */
export function safeNum(v: unknown): number {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
}

/**
 * Maps GraphQL review feedback field names to display labels and ValueTag types.
 * Single source of truth — used by useDashboardData, useValueDelivered, and MyExpertsCard.
 */
export const VALUE_FEEDBACK_FIELDS = [
  {
    field: 'time_savings_feedback',
    label: 'Time Savings',
    tagType: 'time-savings' as ValueTagType,
  },
  {
    field: 'improved_bid_confidence_feedback',
    label: 'Bid Confidence',
    tagType: 'bid-confidence' as ValueTagType,
  },
  {
    field: 'partner_identification_feedback',
    label: 'Partner ID',
    tagType: 'partner-id' as ValueTagType,
  },
  {
    field: 'cost_savings_feedback',
    label: 'Cost Savings',
    tagType: 'cost-savings' as ValueTagType,
  },
  {
    field: 'new_opportunity_identification_feedback',
    label: 'New Opp',
    tagType: 'new-opportunities' as ValueTagType,
  },
] as const;

/** Lookup from display label to ValueTagType. */
export const VALUE_TAG_MAP: Record<string, ValueTagType> = Object.fromEntries(
  VALUE_FEEDBACK_FIELDS.map(({ label, tagType }) => [label, tagType])
) as Record<string, ValueTagType>;
